import React, { useEffect, useMemo, useState } from 'react';
import { getCoreRowModel } from '@tanstack/react-table';

// MUI Theme
import { Paper } from '@mui/material';

// Services
import { exportReaderReportByImei, getReaderReportByImei } from '../../../services/readerReport.service';

// Utils
import { useExport } from '../../../hooks/useExport';
import { makeReportListColumn } from '../../../utils/columns/makeColumn';

// Redux
import { useAppDispatch } from '../../../redux/hook';
import { updateReaderReportState } from '../../../redux/slices/readerReportSlice';

// Types
import { Reader } from '../../../types/Reader';
import { FilterableTypes } from '../../../types/FilterableTypes';

// Common Components
import { useStandardTable as useTable, Table } from '../../common/table/index';

interface ReaderReportProp {
  reader: Reader;
  accessKey?: string;
  shouldFetch: boolean;
  onRowClick?: (row: any) => void;
}

export default function ReaderReports(props: ReaderReportProp): JSX.Element {
  const dispatch = useAppDispatch();
  const [paramFilter, setParamFilter] = useState<any>({
    entityType: 'ReaderReport',
    filters: [],
  });

  const { isExporting, startExport } = useExport('ReaderReport');

  useEffect(() => {
    if (props.reader.imei) {
      setParamFilter({
        filters: [{ imei: props.reader.imei, filterType: FilterableTypes.Equals }],
        sortBy: [{ lastSeenDateTime: '-1' }],
      });
    }
  }, [props.reader.imei]);

  const columns = useMemo(() => makeReportListColumn(), []);

  const table = useTable<any>({
    columns,
    accessKey: props.accessKey,
    fetchAsync: getReaderReportByImei,
    exportAsync: exportReaderReportByImei,
    params: paramFilter,
    serverSide: true,
    shouldFetch: props.shouldFetch,
    onRowClick: props.onRowClick,
  });

  useEffect(() => {
    if (table.data.length > 0) {
      dispatch(updateReaderReportState(table.data));
    }
  }, [table.data]);

  return (
    <Paper>
      <Table
        {...table}
        isExporting={isExporting}
        canExportData={() => true}
        exportData={() => startExport(paramFilter.filters ?? [])}
        showSearchBar={false}
        showColumnToggler={false}
        showAction={true}
        showSpinner={false}
        getCoreRowModel={getCoreRowModel()}
      />
    </Paper>
  );
}
